import request from '@/axios'
/**
 * @Description: 获取合作伙伴列表
 */
export function getAllPartners() {
    return request({
        method: 'get',
        url: '/api/enterprise/selectEnterprisesLessValidEndDate',
    })
}